import React from "react";
import BannerBG from "../../../assets/products-banner-bg.png";
import DefaultBannerIMG from "../../../assets/products-banner-image.png";
import { Link } from "react-router-dom";

function ProductsBannerSection({ acfData }) {
  // Set fallback/default content
  const defaultData = {
    title: "All in One PMS, POS and Tour Booking Platform",
    description:
      "Optimize your workflow and focus on delivering exceptional experiences with Laguna Creek's powerful booking software designed for tour operators.",
    buttonText: "Request A Demo",
    buttonUrl: "/contact-us",
    bannerImage: DefaultBannerIMG,
  };

  // Pull from API if available, otherwise use default
  const title =
    acfData?.all_in_one_pms_pos_and_tour_booking_platform || defaultData.title;
  const description =
    acfData?.all_in_one_pms_pos_and_tour_booking_platform_detail ||
    defaultData.description;
  const buttonText =
    acfData?.all_in_one_pms_pos_and_tour_booking_platform_button_text ||
    defaultData.buttonText;
  // const buttonUrl = acfData?.all_in_one_pms_pos_and_tour_booking_platform_button_url
  //   ? new URL(acfData.all_in_one_pms_pos_and_tour_booking_platform_button_url)
  //       .pathname
  //   : defaultData.buttonUrl;
  const rawButtonUrl = acfData?.all_in_one_pms_pos_and_tour_booking_platform_button_url;
const buttonUrl =
  typeof rawButtonUrl === "string" && rawButtonUrl.startsWith("/")
    ? rawButtonUrl
    : defaultData.buttonUrl;

  const bannerImage =
    acfData?.all_in_one_pms_pos_and_tour_booking_platform_image || defaultData.bannerImage;

  return (
    <section
      className="py-10 lg:py-20 overflow-hidden"
      style={{ backgroundImage: `url(${BannerBG})` }}
    >
      <div className="w-full max-w-[1570px] px-4 mx-auto">
        <div className="flex flex-wrap items-center -mx-4">
          <div className="w-full lg:w-1/2 min-[1800px]:w-1/5 max-w-full px-4 text-center lg:text-left">
            <div className="min-[1800px]:w-[671px]">
              <h3 className="text-[30px] md:text-[40px] lg:text-[52px] font-normal leading-tight text-[#5fa3b2] mb-6">
                {title}
              </h3>
              <p className="text-lg font-light leading-7 text-[#333333] mb-8">
                {description}
              </p>
              <Link
                to={buttonUrl}
                className="inline-block text-lg font-bold leading-6 text-white bg-[#5FA3B2] border border-[#5FA3B2] py-[17px] px-[17px] md:px-[35px] rounded-xl transition-all ease-in-out duration-500 hover:text-[#5FA3B2] hover:bg-[transparent] mb-8 lg:mb-0"
              >
                {buttonText}
              </Link>
            </div>
          </div>
          <div className="w-full lg:w-1/2 min-[1800px]:w-4/5 max-w-full px-4">
            <img
              src={bannerImage}
              alt="Product Banner"
              className="min-[1800px]:relative min-[1800px]:left-[210px]"
              height="441"
              width="1176"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default ProductsBannerSection;
